// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"BAGroup--next-sr-only--3l5TkC8","pileCardBtnContainer":"BAGroup--pileCardBtnContainer--2iNwBu8"};